import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createProvider } from "./vue-apollo";
import Vue2Filters from "vue2-filters";
import VueMasonry from "vue-masonry-css";
import Vuelidate from "vuelidate";
import VueMq from "vue-mq";
import vueAwesomeCountdown from "vue-awesome-countdown";
import TextareaAutosize from "vue-textarea-autosize";
import infiniteScroll from 'vue-infinite-scroll'

import Toasted from "vue-toasted";

import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster";
import VueNumerals from "vue-numerals";

import GAuth from "vue-google-oauth2";

import VueCurrencyInput from "vue-currency-input";

let SocialSharing = require("vue-social-sharing");

import DefaultLayout from "./layouts/DefaultLayout";
import AuthLayout from "./layouts/AuthLayout";
import linkify from "vue-linkify";

import userExist from "./assets/js/initUser";

Vue.directive("linkified", linkify);

Vue.component("GmapCluster", GmapCluster);

Vue.component("default-layout", DefaultLayout);
Vue.component("auth-layout", AuthLayout);

Vue.config.productionTip = false;

Vue.use(VueNumerals);
Vue.use(Vue2Filters);
Vue.use(SocialSharing);
Vue.use(VueMasonry);
Vue.use(Vuelidate);
Vue.use(vueAwesomeCountdown, "vac");
Vue.use(TextareaAutosize);
Vue.use(VueCurrencyInput);
Vue.use(require("vue-moment"));
Vue.use(Toasted, {
  fullWidth: true,
  fitToScreen: true,
  position: "top-center",
  theme: "pretiis-toast",
  duration: 6000,
  action: {
    text: "\u2715",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
});

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_GAUTH,
  scope: "profile email",
  prompt: "select_account",
  secret: process.env.VUE_APP_GOOGLE_GAUTH_SECRET
};
Vue.use(GAuth, gauthOption);

Vue.use(infiniteScroll);

// TODO Update Google KEY
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: "places" // This is required if you use the Autocomplete plugin
  },

  installComponents: true
});

Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1440
  },
  defaultBreakpoint: "xl" // customize this for SSR
});

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

userExist();

Vue.prototype.$twilioClient = { client: "" };

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
